import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {HomepageAiFeaaturesPanelProps} from '@Panels/homepage-ai-features-panel/homepage-ai-features-panel.types';
import {PANEL_ID} from '@Panels/homepage-ai-features-panel/homepage-ai-features-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

export type HomepageAiFeaturesModalProps = HomepageAiFeaaturesPanelProps;

export default function HomepageAiFeaturesModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.HOMEPAGE_AI_FEATURES_MODAL];
  });

  const height = 'auto';
  const width = '360px';

  return (
    <Modal
      modalId={MODALS_IDS.HOMEPAGE_AI_FEATURES_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      modalWidth={width}
      modalMaxWidth={width}
      animatesBottomUp
      stickToBottom
      isBottomSheetOnMobile
    >
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openHomepageAiFeaturesModal = (props: HomepageAiFeaturesModalProps = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.HOMEPAGE_AI_FEATURES_MODAL,
      panelProps: props,
    })
  );
};
